import {OptionList} from './types';

export const setSelection = <T>(options: OptionList<T>, targetState: boolean) =>
  options.map((o) => ({
    ...o,
    selected: targetState,
  }));
